import { useApiConfigStore } from "@store/api_config";

/**
 * Build the URL to the backend vehicle-image endpoint.
 * The backend handles caching in GCS and fetching from imagin.studio if needed.
 */
export function getVehicleImageUrl(
  marque?: string,
  modele?: string,
  coloris?: string,
  mec?: number,
): string | null {
  if (!marque || !modele) return null;

  const baseUrl = useApiConfigStore.getState().getApiUrl();
  const params = new URLSearchParams({
    make: marque,
    model: modele,
    color: coloris || "gris",
  });
  if (mec) params.set("year", String(mec));

  return `${baseUrl}/public/vehicle-image?${params.toString()}`;
}
